export var schema = {
  title: "Property Loss",
  description: "Property Loss Claim Form",
  type: "object",
  properties: {
    incident: {
      type: "object",
      title: "Incident",
      required: ["insureddateloss", "incidentAddress", "incidentDescription", "incidentisCovered"],
      properties: {
        insureddateloss: {
          title: "Date and Time When Incident Occurred?",
          type: "string",
          format: "date-time"
        },
        incidentAddress: {
          type: "string",
          title: "Address Where Incident Occurred?"
        },
        incidentLat: {
          type: "string",
          title: "Latitude"
        },
        incidentLong: {
          type: "string",
          title: "Longitude"
        },
        incidentDescription: {
          type: "string",
          title: "Description of What Occurred?"
        },
        incidentisCovered: {
          title: "Is this Incident Covered Under Any Other Policy of Insurance?",
          type: "string",
          enum: ["Yes", "No"]
        }
      }
    },
    theft: {
      type: "object",
      title: "Theft",
      required: ["theftClaim"],
      properties: {
        theftClaim: {
          title: "Is this a Theft or Burglar Claim?",
          type: "string",
          enum: ["Yes", "No"]
        }
      },
      dependencies: {
        theftClaim: {
          oneOf: [{
            properties: {
              theftClaim: {
                enum: ["Yes"]
              },
              theftClaimDetails: {
                type: "object",
                title: "",
                properties: {
                  theftAlarmWorking: {
                    title: "Is There a Working Alarm at the Insured Premise Where Loss or Damage Took Place?",
                    type: "string",
                    enum: ["Yes", "No"]
                  },
                  theftDescription: {
                    title: "Full Description of How Entry was Gained at the Property",
                    type: "string"
                  }
                }
              },
              police: {
                type: "object",
                title: "",
                required: ["policeReported"],
                properties: {
                  policeReported: {
                    type: "string",
                    title: "Was the Incident Reported to the Police?",
                    enum: ["Yes", "No"]
                  }
                },
                dependencies: {
                  policeReported: {
                    oneOf: [{
                      properties: {
                        policeReported: {
                          enum: ["Yes"]
                        },
                        reportDetails: {
                          type: "object",
                          title: "Police Report Details",
                          required: ["policePlaceReported", "policeDateReported", "policeCaseNumber"],
                          properties: {
                            policePlaceReported: {
                              title: "Police Station Where Incident Reported",
                              type: "string"
                            },
                            policeDateReported: {
                              title: "Date Reported",
                              type: "string",
                              format: "date"
                            },
                            policeCaseNumber: {
                              title: "SAPS Case Number",
                              type: "string"
                            }
                          }
                        }
                      }
                    }, {
                      properties: {
                        policeReported: {
                          enum: ["No"]
                        },
                        reportNote: {
                          type: "null",
                          title: "Please Report Incident to Police and Update Your Broker."
                        }
                      }
                    }]
                  }
                }
              }
            }
          }, {
            properties: {
              theftClaim: {
                enum: ["No"]
              }
            }
          }]
        }
      }
    },
    otherParty: {
      type: "object",
      title: "Loss Caused by Other Parties",
      required: ["otherPartyIncident"],
      properties: {
        otherPartyIncident: {
          title: "Was the Incident Caused by Other Parties?",
          type: "string",
          enum: ["Yes", "No"]
        }
      },
      dependencies: {
        otherPartyIncident: {
          oneOf: [{
            properties: {
              otherPartyIncident: {
                enum: ["Yes"]
              },
              otherPartyIncidentDetails: {
                type: "object",
                title: "",
                required: ["name"],
                properties: {
                  name: {
                    title: "Other Party Name",
                    type: "string"
                  },
                  contactNumber: {
                    title: "Other Party Contact Number",
                    type: "string",
                    minLength: 10
                  },
                  email: {
                    title: "Other Party Contact Email",
                    type: "string",
                    format: "email"
                  },
                  address: {
                    type: "string",
                    title: "Other Party Physical Address"
                  },
                  lat: {
                    type: "string",
                    title: "Latitude"
                  },
                  long: {
                    type: "string",
                    title: "Longitude"
                  }
                }
              }
            }
          }, {
            properties: {
              otherPartyIncident: {
                enum: ["No"]
              },
              reportNote: {
                type: "null",
                title: "Please Report Incident to Police and Update Your Broker."
              }
            }
          }]
        }
      }
    },
    attachments: {
      type: "object",
      title: "Attachments",
      description: `Please Attach the Following Documents if Applicable:
      - Alarm Activation Report
      - List of Damaged or Stolen Items
      - Invoice of Replaced or Repaired Item
      - Original Receipts
      - Valuation Reports
      - Police Report
      - Photos of Damage Area`,  
      properties: {
        attachmentsList: {
          title: "Attachments",
          type: "array",
          description: "File Names Should Not Have Any Round Brackets. ()",
          items: {
            type: "object",
            properties: {
              attachment: {
                type: "array",
                title: "Attachment",
                items: [{
                  key: "attachName",
                  title: "Title",
                  type: "string",
                  maxLength: 200
                }, {
                  key: "attachmentContent",
                  type: "array",
                  title: "Attachment",
                  items: {
                    type: "string",
                    format: "data-url"
                  }
                }]
              }
            }
          }
        }
      }
    },
    declaration: {
      type: "object",
      title: "Declaration",
      required: ["insuredaccepttc"],
      description: "I/we declare that to the best of my/our knowledge the above statements are true. I acknowledge that the information set out above is provided freely so that Western may process my claim and give effect to the terms and conditions contained in the policy wording. I herewith give my consent that Western may use this information, my personal information on record and additional information obtained from other sources in order to determine whether to accept or reject my claim and take all necessary steps ancillary thereto to give effect hereto. I understand that I may be liable for output VAT in terms of section 8(8) of the VAT Act 89 of 1991.",
      properties: {
        insuredaccepttc: {
          type: "boolean",
          title: "Accept Terms and Conditions",
          description: "Tick Box to Accept Terms and Conditions"
        },
        insuredcapcity: {
          type: "string",
          title: "Capacity"
        },
        insureddate: {
          type: "string",
          title: "Date",
          format: "date"
        }
      }
    }
  }
};

export var uiSchema = {
  incidentLat: {
    "ui:widget": "hidden"
  },
  incidentLong: {
    "ui:widget": "hidden"
  },
  incidentDescription: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  theftClaimDetails:{
    theftDescription: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 5
      }
    }
  },
  police: {
    reportDetails: {
      policePlaceReported: {
        "ui:widget": "textarea",
        "ui:options": {
          rows: 5
        }
      }
    }
  },
  otherPartyIncidentDetails: {
    lat: {
      "ui:widget": "hidden"
    },
    long: {
      "ui:widget": "hidden"
    }
  },
  incidentCause: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  }
};